import React, { useCallback, useEffect } from "react";
import { keys } from "lodash";
import { get, sortBy, map, size, groupBy } from "lodash";
import { Col, Row, Card, Form, Typography, DatePicker } from "antd";
import styled from "styled-components";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Exporting from "highcharts/modules/exporting";
import { useSelector, useDispatch } from "react-redux";
import dayjs from "dayjs";

import { barrierThunks } from "../../_redux/thunk";
import AppBaseSelect from "../../../../../core/components/baseSelect";
Exporting(Highcharts);

const { Text } = Typography;

const BarrierDashboardPage = ({ className }) => {
  const CARD_STYLE = {
    borderRadius: "0.42rem",
    boxShadow: "0px 0px 30px 0px rgba(82, 63, 105, 0.05)"
  };
  const today = new Date();

  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const { data } = useSelector(
    state => state.barrier.barrierDashboard.dashboard
  );

  const {
    direction,
    directions,
    stations,
    recognize_type,
    recognize_types
  } = useSelector(state => state.barrier.barrierDashboard.filterData);

  const _handleGetDashboardData = useCallback(async () => {
    const { station_id, date } = form.getFieldsValue();
    const dateTransformed = dayjs(date).format("YYYY-MM-DD");
    await dispatch(
      barrierThunks.getDashboardThunk(station_id || 17548, dateTransformed)
    );
  }, []);

  const _handleGetFilterData = useCallback(async () => {
    await dispatch(barrierThunks.getDashboardFilterDataThunk());
  }, []);

  const dates = keys(groupBy(data.gate_pass_report, item => item.date));

  // Transform gate pass data
  const gatePasses = map(directions, direction => {
    const directionKey = direction.toLowerCase();
    const totalPasses = [];
    if (size(data.gate_pass_report)) {
      for (let i = 0; i < size(data.gate_pass_report); i++) {
        totalPasses.push(get(data.gate_pass_report[i], directionKey, {}));
      }
    }
    return {
      direction: directionKey,
      totalPasses: totalPasses
    };
  });

  const gate_pass_report = map(gatePasses, item => ({
    name: direction[item.direction.toUpperCase()],
    data: item.totalPasses
  }));

  // Transform recognition report
  const recognizeTypes = map(recognize_types, type => {
    const recognizeKey = type.toLowerCase();
    const totalLogs = [];
    if (size(data.recognition_report)) {
      for (let i = 0; i < size(data.recognition_report); i++) {
        totalLogs.push(get(data.recognition_report[i], recognizeKey, {}));
      }
    }
    return {
      type,
      totalPasses: totalLogs
    };
  });

  const recognition_report = map(recognizeTypes, item => ({
    name: recognize_type[item.type],
    data: item.totalPasses
  }));

  // Transform recognition gate report
  const recognition_gates = map(data.recognition_gates, (item, index) => {
    const validLog = item?.valid_log || 0;
    const recognizableLog = item?.recognizable_log || 0;
    const unrecognizableLog = item?.unrecognizable_log || 0;
    const total = validLog + recognizableLog + unrecognizableLog;
    return {
      key: index,
      title: item.gate_name,
      data: [
        {
          name: `${recognize_type?.valid_log}: ${item.valid_log} (${
            (validLog / total) * 100 ? ((validLog / total) * 100).toFixed(0) : 0
          }%)`,
          y: validLog
        },
        {
          name: `${recognize_type?.recognizable_log}: ${recognizableLog} (${
            (recognizableLog / total) * 100
              ? ((recognizableLog / total) * 100).toFixed(0)
              : 0
          }%)`,
          y: recognizableLog
        },
        {
          name: `${recognize_type?.unrecognizable_log}: ${unrecognizableLog} (${
            (unrecognizableLog / total) * 100
              ? ((unrecognizableLog / total) * 100).toFixed(0)
              : 0
          }%)`,
          y: unrecognizableLog
        }
      ]
    };
  });

  useEffect(
    () => {
      _handleGetFilterData();
      _handleGetDashboardData();
      let loopInterval = setInterval(() => {
        _handleGetDashboardData();
      }, 30000);
      return () => {
        clearInterval(loopInterval);
      };
    },
    [_handleGetFilterData, _handleGetDashboardData]
  );
  return (
    <Row className="sms-dashboard__page" gutter={[8, 8]} className={className}>
      <Col span={24}>
        <Card
          bodyStyle={{ paddingBottom: "0" }}
          size="small"
          style={CARD_STYLE}
        >
          <Row align="middle" justify="space-between" span={24}>
            <Form
              form={form}
              layout={"vertical"}
              style={{ width: "100%" }}
              initialValues={{
                date: dayjs(),
                station_id: 17548
              }}
            >
              <Row gutter={[16, 0]}>
                <Col className="gutter-row" span={4}>
                  <Form.Item label="Ngày" name={"date"}>
                    <DatePicker
                      style={{ width: "100%" }}
                      placeholder="Chọn ngày"
                      format={"YYYY-MM-DD"}
                      onChange={_handleGetDashboardData}
                    />
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                  <Form.Item label="Kho" name="station_id">
                    <AppBaseSelect
                      allowConvert={true}
                      placeholder="Kho"
                      dataSource={stations}
                      valueKey="station_id"
                      labelKey="station_name"
                      onChange={_handleGetDashboardData}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Row>
        </Card>
      </Col>
      <Col span={8}>
        <Card title="Tổng số log" bordered={true}>
          <Text className="text-primary">{data.in_day_report?.total || 0}</Text>
        </Card>
      </Col>
      <Col span={8}>
        <Card title="Tổng log ra/vào" bordered={true}>
          <Text className="text-primary">
            {`${data.in_day_report?.out || 0}/${data.in_day_report?.in || 0}`}
          </Text>
        </Card>
      </Col>
      <Col span={8}>
        <Card title="Tổng log đọc được biển số" bordered={true}>
          <Text className="text-primary">
            {data.in_day_report?.recognizable_log || 0}
          </Text>
        </Card>
      </Col>
      <Col span={12}>
        <Card style={{ height: "100%" }}>
          <HighchartsReact
            highcharts={Highcharts}
            options={{
              colors: ["#069255", "#2db7f5"],
              chart: {
                type: "column",
                height: 360
              },
              title: {
                text: "Số lượng log ra/vào",
                style: {
                  fontWeight: "bold",
                  fontSize: 15
                },
                align: "left"
              },
              xAxis: {
                categories: dates
              },
              yAxis: {
                stackLabels: {
                  enabled: true,
                  style: {
                    fontWeight: "bold"
                  }
                },
                labels: {
                  formatter: values => {
                    return values.value;
                  }
                },
                title: {
                  text: null
                }
              },
              legend: {
                align: "center",
                verticalAlign: "bottom",
                floating: false,
                backgroundColor: "white",
                borderColor: "#CCC",
                borderWidth: 1,
                shadow: false
              },
              tooltip: {
                headerFormat: "<b>{point.x}</b><br/>",
                pointFormat:
                  "{series.name}: {point.y}<br/>Tổng: {point.stackTotal}"
              },
              plotOptions: {
                column: {
                  stacking: "normal",
                  dataLabels: {
                    enabled: true,
                    color: "black",
                    style: {
                      textOutline: 0
                    }
                  },
                  pointWidth: 40
                }
              },
              credits: {
                enabled: false
              },
              series: sortBy(gate_pass_report, [e => e.name])
            }}
          />
        </Card>
      </Col>
      <Col span={12}>
        <Card style={{ height: "100%" }}>
          <HighchartsReact
            highcharts={Highcharts}
            options={{
              colors: ["#069255", "#2db7f5", "#F44336"],
              chart: {
                type: "column",
                height: 360
              },
              title: {
                text: "Số lượng log hợp lệ/không hợp lệ",
                style: {
                  fontWeight: "bold",
                  fontSize: 15
                },
                align: "left"
              },
              xAxis: {
                categories: dates
              },
              yAxis: {
                stackLabels: {
                  enabled: true,
                  style: {
                    fontWeight: "bold"
                  }
                },
                labels: {
                  formatter: values => {
                    return values.value;
                  }
                },
                title: {
                  text: null
                }
              },
              legend: {
                align: "center",
                verticalAlign: "bottom",
                floating: false,
                backgroundColor: "white",
                borderColor: "#CCC",
                borderWidth: 1,
                shadow: false
              },
              tooltip: {
                headerFormat: "<b>{point.x}</b><br/>",
                pointFormat:
                  "{series.name}: {point.y}<br/>Tổng: {point.stackTotal}"
              },
              plotOptions: {
                column: {
                  stacking: "normal",
                  dataLabels: {
                    enabled: true,
                    color: "black",
                    style: {
                      textOutline: 0
                    }
                  },
                  pointWidth: 40
                }
              },
              credits: {
                enabled: false
              },
              series: recognition_report
            }}
          />
        </Card>
      </Col>
      {recognition_gates.map(item => {
        return (
          <Col span={8} key={item.key}>
            <Card style={{ height: "100%" }}>
              <HighchartsReact
                highcharts={Highcharts}
                options={{
                  colors: ["#069255", "#2db7f5", "#F44336"],
                  chart: {
                    type: "pie",
                    height: 360
                  },
                  title: {
                    text: item.title,
                    style: {
                      fontWeight: "bold",
                      fontSize: 15
                    },
                    align: "left"
                  },
                  xAxis: {
                    categories: dates
                  },
                  legend: {
                    align: "center",
                    verticalAlign: "bottom",
                    floating: false,
                    backgroundColor: "white",
                    borderColor: "#CCC",
                    borderWidth: 1,
                    shadow: false
                  },
                  tooltip: {
                    headerFormat: "<b>{point.key}</b><br/>",
                    pointFormat: null
                  },
                  credits: {
                    enabled: false
                  },
                  plotOptions: {
                    pie: {
                      allowPointSelect: true,
                      cursor: "pointer",
                      dataLabels: {
                        enabled: false,
                        style: {
                          textOutline: 0
                        }
                      },
                      showInLegend: true
                    }
                  },
                  series: [
                    {
                      data: item.data,
                      dataLabels: {
                        verticalAlign: "center",
                        enabled: true,
                        color: "#000000",
                        connectorWidth: 1,
                        distance: -30,
                        connectorColor: "#000000",
                        formatter: function() {
                          if (this.percentage <= 0) return "";
                          return Math.round(this.percentage) + " %";
                        }
                      }
                    }
                  ]
                }}
              />
            </Card>
          </Col>
        );
      })}
    </Row>
  );
};

export default styled(BarrierDashboardPage)`
    .apexcharts-title-text {
      font-weight: bold;
      font-size: 15px;
    }
    .ant-card-head-title {
      font-weight: bold;
      font-size: 15px;
      padding: 6px 0px 6px 0px;
    }
    .ant-typography {
      font-weight: bold;
      font-size: 15px;
    }
    .ant-card-body {
      padding: 6px;
    }
    .ant-card-head {
      padding: 0px 6px 0px 6px;
      min-height: 30px;
    }
    .ant-card {
      max-height: 380px;
    }
    ,
    .ant-card-grid {
      padding: 6px;
    }
  }
`;
